var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnTableCellSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3535 2.75L11.6201 4.56543L11.6836 4.99121L12.083 5.15234C12.5175 5.32679 12.9277 5.55723 13.3018 5.83887L13.6357 6.09082L14.0254 5.93848L15.8018 5.24414L17.1387 7.49219L15.6562 8.62012L15.3037 8.8877L15.3682 9.32617C15.4342 9.77336 15.4342 10.2286 15.3682 10.6758L15.3037 11.1133L15.6562 11.3818L17.1357 12.5078L15.7998 14.7559L14.0225 14.0625L13.6348 13.9111L13.3018 14.1592C12.9246 14.4403 12.5129 14.6722 12.0771 14.8496L11.6797 15.0117L11.6182 15.4365L11.3545 17.2334L9.24414 17.1465L9.38281 17.25H8.65137L8.38379 15.4346L8.32129 15.0068L7.9209 14.8467L7.59961 14.7061C7.28401 14.5547 6.98391 14.3724 6.7041 14.1611L6.36914 13.9082L5.97949 14.0605L4.20215 14.7549L2.86523 12.5068L4.3457 11.3809L4.69824 11.1123L4.63281 10.6738C4.5668 10.2268 4.56677 9.77227 4.63281 9.3252L4.69824 8.88672L4.3457 8.61914L2.86426 7.49219L4.20117 5.24414L5.97949 5.93848L6.36621 6.08984L6.69922 5.8418C7.07731 5.56073 7.48968 5.32858 7.92578 5.15039L8.32129 4.98828L8.38379 4.56543L8.65137 2.75H11.3535Z",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99965,
    cy: 9.99965,
    r: 2.88636,
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnTableCellSettings);
export default __webpack_public_path__ + "static/media/icn_table_cell_settings.fced7d18917c110348f9eab8e26e9398.svg";
export { ForwardRef as ReactComponent };